<template>
<div class="chapter">
<div class="inner_page">
<h2 class="Abb"><a id="pagevi">List of Plates</a></h2><a id="pagevi">
<p class="list_fig"><span class="list_fighang">1.</span> Jo Holland (1938), head of MI(R).</p>
<p class="list_fig"><span class="list_fighang">2.</span> Colin Gubbins, MI(R) and head of SOE.</p>
<p class="list_fig"><span class="list_fighang">3.</span> Millis Jefferis, head of MI(R)c.</p>
<p class="list_fig"><span class="list_fighang">4.</span> Laurence Grand, head of Section D, SIS.</p>
<p class="list_fig"><span class="list_fighang">5.</span> Daniel Sandford in Ethiopia, January 1941.</p>
<p class="list_fig"><span class="list_fighang">6.</span> Peter Fleming, MI(R) and XII Corps Observation Unit.</p>
<p class="list_fig"><span class="list_fighang">7.</span> Alan Warren’s MI(R) identity card.</p>
<p class="list_fig"><span class="list_fighang">8.</span> Limpet mine, showing how it was carried by a diver to the target.</p>
<p class="list_fig"><span class="list_fighang">9.</span> Grenade No. 74 ST – the Sticky Bomb.</p>
<p class="list_fig2"><span class="list_fighangH">10.</span> 29mm spigot mortar (‘Blacker Bombard’).</p>
<p class="list_fig2"><span class="list_fighangH">11.</span> Switch No. 1 Pull.</p>
<p class="list_fig2"><span class="list_fighangH">12.</span> Switch No. 2 Pressure.</p>
<p class="list_fig2"><span class="list_fighangH">13.</span> Switch No. 3 Release.</p>
<p class="list_fig2"><span class="list_fighangH">14.</span> Switch No. 8 AP.</p>
<p class="list_fig2"><span class="list_fighangH">15.</span> Switch No. 9 L Delay.</p>
<p class="list_fig2"><span class="list_fighangH">16.</span> Autogyro, 1938.</p>
<p class="list_fig2"><span class="list_fighangH">17.</span> Extract from <em class="italic">How to Use High Explosives</em>, 1939.</p>
<p class="list_fig2"><span class="list_fighangH">18.</span> Webley Mk. VI revolver and Colt 1903 automatic pistol, as supplied to the Polish resistance.</p>
<p class="list_fig2"><span class="list_fighangH">19.</span> Aerial photograph of Lochailort.</p>
<p class="list_fig2"><span class="list_fighangH">20.</span> Inverailort Castle.</p>
<p class="list_fig2"><span class="list_fighangH">21.</span> Silk escape map of Romania, produced by MI9.</p>
<p class="list_fig2"><span class="list_fighangH">22.</span> Early miniature compass produced by MI9.</p>
<p class="list_fig2"><span class="list_fighangH">23.</span> Ploisti oilfield under aerial attack, 1943.</p>
<p class="list_fig2"><span class="list_fighangH">24.</span> Dymock Watson, head of MI(R) in Romania.</p>
<p class="list_fig2"><span class="list_fighangH">25.</span> No. 4 Independent Company shoulder flash (reproduction).</p>
<p class="list_fig2"><span class="list_fighangH">26.</span> Armed ‘Puffer’ of the type used by the ‘Gubbins Flotilla’ in Norway.</p>
<p class="list_fig2"><span class="list_fighangH">27.</span> Bridge destroyed by the British at Mo i Rana, Norway.</p>
</a><a id="pagevii">
<p class="list_fig2"><span class="list_fighangH">28.</span> Bridge at Potthus, Norway, under repair by the German Army.</p>
<p class="list_fig2"><span class="list_fighangH">29.</span> Ethiopian Patriots being trained at El Wak on the Somalia/Kenya border in early 1941.</p>
<p class="list_fig2"><span class="list_fighangH">30.</span> Martini-Enfield single shot .303 calibre rifle of the type supplied to the Ethiopian Patriots.</p>
<p class="list_fig2"><span class="list_fighangH">31.</span> Badges of Middle East Command and Sudan Defence Force.</p>
<p class="list_fig2"><span class="list_fighangH">32.</span> Maria Theresa Thaler, as provided by Mission 101 to the Ethiopian Patriots.</p>
<p class="list_fig2"><span class="list_fighangH">33.</span> Reconnaissance photograph of Leopoldville taken by Mission 19 in the Belgian Congo.</p>
<p class="list_fig2"><span class="list_fighangH">34.</span> Badges of General Service Corps and Intelligence Corps.</p>
<p class="list_fig2"><span class="list_fighangH">35.</span> Major General Jo Holland (1947).</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// List_of_Plates.vue?2dfc067b